<template>
	<div class="py-4 container-fluid">
    <div class="row">
        <div class="col-md-12">
					<div class="card" v-if="isLoading">
						<Loading/>
					</div>
          <div class="card" v-if="!isLoading">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="mb-0">Ejecución de Contrato {{ contract.Name }}</p>
              </div>
            </div>
            <div class="card-body">
              <p class="text-uppercase text-sm">	Detalles</p>
              <div class="row">
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Cliente</label
                  >
                  <argon-input type="text" v-model="contract.Cliente__c" disabled="true" />
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >País</label
                  >
                  <argon-input type="text" v-model="contract.Pais__c" disabled="true" />
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Estado</label
                  >
                  <argon-input type="text" v-model="contract.EstadoDeCampana__c" disabled="true" />
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Marca</label
                  >
                  <argon-input type="text" v-model="contract.Marca__c" disabled="true" />
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Fecha Inicio</label
                  >
                  <argon-input type="text" v-model="contract.Campana__c.FechaDeInicio__c" disabled="true" />
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Fecha Finalizacion</label
                  >
                  <argon-input type="text" v-model="contract.FechaDeFinalizacion__c" disabled="true" />
                </div>
              </div>
              <hr class="horizontal dark" />
              <div class="nav nav-tabs nav-fill" id="myTab" role="tablist">
                <li class="nav-item" role="presentation">
                  <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#installs" type="button" role="tab" aria-controls="installs" aria-selected="true">Instalaciones</button>
                </li>
              </div>
              <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="installs" role="tabpanel" aria-labelledby="installs-tab">
                  <p class="text-uppercase text-sm text-center">	Detalles de instalaciones</p>
                  <div class="table-responsive" v-if="hasInstalls">
                    <table class="table align-items-center">
                      <tbody>
                        <Loading v-if="isLoading"/>
                        <tr v-for="(install, index) in installs" :key="index">
                          <td>
                            <div class="px-2 py-1 d-flex align-items-center">
                              <div class="ms-4">
                                <p class="mb-0 text-xs font-weight-bold">Código:</p>
                                <h6 class="mb-0 text-sm"><a :href="'/install/'+install._id">{{ install.Name }}</a></h6>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="text-center">
                              <p class="mb-0 text-xs font-weight-bold">Contrato:</p>
                              <h6 class="mb-0 text-sm" v-if="install.Campana__c !=null">{{ install.Campana__c.Name }}</h6>
                            </div>
                          </td>
                          <td>
                            <div class="text-center">
                              <p class="mb-0 text-xs font-weight-bold">Producto:</p>
                              <h6 class="mb-0 text-sm">{{ install.Producto__c }}</h6>
                            </div>
                          </td>
                          <td>
                            <div class="text-center">
                              <p class="mb-0 text-xs font-weight-bold">Marca:</p>
                              <h6 class="mb-0 text-sm">{{ install.Marca__c }}</h6>
                            </div>
                          </td>
                          <td class="text-sm align-middle">
                            <div class="text-center col">
                              <p class="mb-0 text-xs font-weight-bold">Sitio:</p>
                              <h6 class="mb-0 text-sm">{{ install.Sitio__c }}</h6>
                            </div>
                          </td>
                          <td class="text-sm align-middle">
                            <div class="text-center col">
                              <p class="mb-0 text-xs font-weight-bold">Fecha:</p>
                              <h6 class="mb-0 text-sm" v-if="install.FechaInstalacion__c !=null">{{ getFormattedDate(install.FechaInstalacion__c) }}</h6>
                            </div>
                          </td>
                          <td class="text-sm align-middle">
                            <div class="text-center col">
                              <p class="mb-0 text-xs font-weight-bold">Estado:</p>
                              <h6 class="mb-0 text-sm">{{ install.Estado__c }}</h6>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-if="!hasInstalls" class="text-center">
                    <img :src="folder" style="max-width: 20%;"/> 
                    <h4>No se encontraron registros</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
  import Loading from '../../examples/Loading.vue';
  import moment from 'moment';
	import ArgonInput from "@/components/ArgonInput.vue";
  import folder from "@/assets/img/folder.png";

  export default {
    name: "tables",
    components: {
      Loading,
			ArgonInput,
    },
    data() {
      return {
        folder,
        contract:{
          Id:null,
					Name:null,
					Cliente__c:null,
					Agencia__c:null,
					EstadoDeCampana__c:null,
          RepresentanteCliente__c:null,
          Marca__c:{
            Name:null
          },
          MediosIncluidosEnContrato__c:null
				},
        installs:[],
        medios:[],
        isLoading:false,
        hasInstalls:false,
        hasMedios:false
      };
    },
    methods:{
      async fetchContract(){
        this.isLoading=true;
				let idContract = this.$route.params.id;
        fetch(this.$EndPoint+'ejecuciones/get_contract/'+idContract)
        .then(response=>response.json())
        .then(result=>{
          console.log(result);
          this.contract=result;
          this.fetchInstalls();
        })
      },
      
      async fetchInstalls(){
        fetch(this.$EndPoint+'instalaciones/get_by_campaign/'+this.contract.Id)
        .then(response=>response.json())
        .then(result=>{
          console.log(result);
          this.installs=result;
          //this.fetchMedios();
          if(this.installs.length>0){
            this.hasInstalls=true;
          }else{
            this.hasInstalls=false;
          }
          console.log('HasInstalls: '+ this.hasInstalls);
          this.isLoading=false;
        })
      },

    
      getFormattedDate(date) {
            return moment(date).format("YYYY-MM-DD")
        }
    },
    created(){
      if(localStorage.getItem('IsLoggedIn')=='true'){
        this.fetchContract();
      }else{
        this.$router.push('/signin')
      }
    }
  };
</script>